import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Spin } from "antd";
import FetchData from "../../../../hooks/FetchData";
import AddingCertificateForm from "../../Addcertificate/Addcertificateflow";

// Adding and Editing a certificate are the same screen in Figma (only the
// breadcrumb, pre-filled values and Add/Save button differ), so this just
// renders the Adding Certificate form in edit mode.
//
// The certificate normally arrives via navigation state from the list, but
// that's lost on a refresh or a pasted link - the ?id= query param lets the
// page load it itself in that case.
function EditCertificate() {
  const location = useLocation();
  const navigate = useNavigate();
  const clientId = useSelector((state) => state.authTracking.userInfo?.clientId);
  const certificateId = new URLSearchParams(location.search).get("id");

  const [certificate, setCertificate] = useState(location.state?.certificate || null);
  const [status, setStatus] = useState(certificate ? "ready" : "loading");

  useEffect(() => {
    if (certificate || !clientId) return;
    if (!certificateId) {
      setStatus("missing");
      return;
    }
    FetchData({ endPoint: `/settings/getcertificate/${clientId}` })
      .then((response) => {
        const found = (response?.response || []).find(
          (item) => String(item.certificate_id) === certificateId
        );
        setCertificate(found || null);
        setStatus(found ? "ready" : "missing");
      })
      .catch(() => setStatus("missing"));
  }, [certificate, certificateId, clientId]);

  const goBackToCertificates = () => navigate("/settings-course", { state: { activeKey: "2" } });

  if (status === "loading") {
    return (
      <div style={{ padding: 48, textAlign: "center" }}>
        <Spin />
      </div>
    );
  }

  if (!certificate) {
    return <p style={{ padding: 32 }}>Certificate not found.</p>;
  }

  return <AddingCertificateForm certificate={certificate} onCancel={goBackToCertificates} />;
}

export default EditCertificate;
